<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>Send SMS</h3>
        <div class="mb-3">
          <strong>To:</strong> {{ client.name }} ({{ client.phone }})
        </div>
        <form @submit.prevent="sendSms">
          <div class="form-group">
            <label>Message <span class="text-danger">*</span></label>
            <textarea 
              v-model="message" 
              class="form-control" 
              rows="5" 
              required
              placeholder="Enter your message here..."
              :maxlength="maxLength"
            ></textarea>
            <small class="text-muted">{{ message.length }} / {{ maxLength }} characters</small>
          </div>

          <div class="text-end mt-3">
            <button 
              class="btn btn-primary" 
              type="submit" 
              :disabled="isSending || !message.trim()">
              {{ isSending ? 'Sending...' : 'Send SMS' }}
            </button>
            <button 
              class="btn btn-secondary" 
              type="button" 
              @click="$emit('input', false)" 
              :disabled="isSending">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    client: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      message: '',
      isSending: false,
      maxLength: 1000
    }
  },
  methods: {
    sendSms() {
      if (!this.message.trim()) {
        Swal.fire({
          title: 'Empty Message!',
          text: 'Please enter a message.',
          icon: 'warning',
          confirmButtonColor: '#3085d6'
        })
        return
      }

      if (!this.client.phone) {
        Swal.fire({
          title: 'Missing Phone!',
          text: 'Client does not have a phone number.',
          icon: 'warning',
          confirmButtonColor: '#3085d6'
        })
        return
      }

      this.isSending = true

      axios.post(`/clients/${this.client.id}/send-sms`, {
        message: this.message,
        phone: this.client.phone
      })
        .then(response => {
          Swal.fire({
            title: 'Sent!',
            text: 'SMS sent successfully!',
            icon: 'success',
            confirmButtonColor: '#3085d6'
          })
          this.$emit('input', false)
          this.$emit('sent')
          this.message = ''
        })
        .catch(error => {
          console.error(error)
          const errorMessage = error.response?.data?.message || 'Error sending SMS. Please try again.'
          Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
            confirmButtonColor: '#3085d6'
          })
        })
        .finally(() => {
          this.isSending = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>

